// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import EventExecutionResourceViewModel from '../../../../viewModel/resource/EventExecutionResourceViewModel';
import EventOccurenceResourceViewModel from '../../../../viewModel/resource/EventOccurenceResourceViewModel';
import EventOccurenceResourceDTO from '../../dto/resource/EventOccurenceResourceDTO';

export default abstract class EventOccurenceResourceModel extends BaseModel<EventOccurenceResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {date-time}
  */
  get startDate() { return this.dto.startDate; }
  set startDate(value) { this.dto.startDate = value; }
  /**
  * @type {date-time}
  */
  get endDate() { return this.dto.endDate; }
  set endDate(value) { this.dto.endDate = value; }
  /**
  * @type {int32}
  */
  get eventExecution() { return this.dto.eventExecution; }
  set eventExecution(value) { this.dto.eventExecution = value; }
  /**
  */
  get room() { return this.dto.room; }
  set room(value) { this.dto.room = value; }
  /**
  */
  get company() { return this.dto.company; }
  set company(value) { this.dto.company = value; }
  /**
  */
  get street() { return this.dto.street; }
  set street(value) { this.dto.street = value; }
  /**
  */
  get city() { return this.dto.city; }
  set city(value) { this.dto.city = value; }
  /**
  */
  get postCode() { return this.dto.postCode; }
  set postCode(value) { this.dto.postCode = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.startDate = qs.startdate;
    this.dto.endDate = qs.enddate;
    value = Number.parseFloat(qs.eventexecution);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.eventExecution = value;
    this.dto.room = qs.room;
    this.dto.company = qs.company;
    this.dto.street = qs.street;
    this.dto.city = qs.city;
    this.dto.postCode = qs.postcode;
  }
}
